
import { apiurl } from '@/services/config'
const API_URL = apiurl + '/backoffice/menu'
export const AppMenuService = {
  list,
  add,
  edit,
  hapus
}

async function list (opt) {
  var sort="id"
  var sorder="ASC"
  if(opt.itemsPerPage<0){
    opt.itemsPerPage=10000
  }
  if(opt.sortBy){
    if(opt.sortBy.length>0){
      sort=opt.sortBy[0]
    }

  }
  if(opt.sortDesc){
    if(opt.sortDesc[0]){
      sorder="DESC"
    }
  }
  let page=opt.page-1;
  let sorting=sort+","+sorder
  return fetch(API_URL+'?cari='+opt.search+'&filtertype='+opt.filtertype+'&filterstatus='+opt.filterstatus+'&page='+page+'&size='+opt.itemsPerPage+"&sort="+sorting, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
    .then(data => {
      console.log(data.data.content)
      return data
    })
}

async function hapus (newsid) {
  return fetch(API_URL + '/' + newsid, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
    .then(data => {
      return data
    })
}

async function add (postdata) {
  return fetch(API_URL, {
    method: 'POST',
    body: JSON.stringify({ postdata }.postdata),
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
    .then(data => {
      return data
    })
}

async function edit (postdata) {
  return fetch(API_URL, {
    method: 'PATCH',
    body: JSON.stringify({ postdata }.postdata),
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
    .then(data => {
      return data
    })
}

function handleResponse (response) {
  return response.text().then(text => {
    const data = text && JSON.parse(text)

    if (!data.success) {
      if (response.status === 401) {
        console.log("CALL LOGOUT");
        localStorage.setItem('token',null);
        localStorage.clear();
        location.reload(true)
      }
      const error = (data && data.msg) || response.statusText
      return Promise.reject(error)
    }
    return data
  })
}
